import { memo, PropsWithChildren, ReactNode } from "react";

import styles from "./chats-layout.module.scss";

const ChatsLayout = ({ children }: PropsWithChildren<ReactNode>) => {
  return <div className={styles.container}>{children}</div>;
};

export default memo(ChatsLayout);
